// extracted by mini-css-extract-plugin
module.exports = {"root":"TransactionStatusBadge_root__3mn9X","pending":"TransactionStatusBadge_pending__952ef"};